import { useState, useCallback } from 'react';

const HOROSCOPES = [
  'Mercury in retrograde. Deploy on Friday.',
  'Your GPU alignment is favorable. Train with confidence.',
  'Beware of floating point errors in your third house.',
  'The stars suggest refactoring your attention mechanism.',
  'A wild segfault approaches. Proceed with caution.',
  'Your embeddings will converge. Patience.',
];

function pickRandom(exclude?: number): number {
  let next: number;
  do {
    next = Math.floor(Math.random() * HOROSCOPES.length);
  } while (next === exclude && HOROSCOPES.length > 1);
  return next;
}

export function ComputeHoroscope() {
  const [index, setIndex] = useState(() => pickRandom());

  const refresh = useCallback(() => {
    setIndex((prev) => pickRandom(prev));
  }, []);

  return (
    <div
      className="social-box rounded overflow-hidden"
      style={{ background: 'var(--bg-card)' }}
    >
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          padding: '4px 6px',
          background: 'var(--bg-card)',
        }}
      >
        <span
          style={{
            fontWeight: 'bold',
            fontSize: 11,
            color: 'var(--accent-purple)',
            letterSpacing: '0.5px',
          }}
        >
          {'\uD83D\uDD2E'} COMPUTE HOROSCOPE
        </span>
        <button
          onClick={refresh}
          style={{
            background: 'none',
            border: 'none',
            cursor: 'pointer',
            fontSize: 12,
            color: 'var(--text-muted)',
            padding: '0 2px',
            lineHeight: 1,
          }}
          title="Refresh horoscope"
        >
          {'\u21BB'}
        </button>
      </div>
      <div style={{ padding: '6px 8px' }}>
        <p className="horoscope-text" style={{ margin: 0, fontSize: 11 }}>
          {HOROSCOPES[index]}
        </p>
      </div>
    </div>
  );
}
